export const NORTH = 'north'
export const SOUTH = 'south'
export const EAST = 'east'
export const WEST = 'west'

export type Direction = 'north' | 'south' | 'east' | 'west'

export interface DropPosition {
  componentId: string
  direction: Direction
}

export interface DropStateStore {
  position?: DropPosition
  eventType?: string
  isVisible: boolean
}

export interface FocusStore {
  currentFocusId: string,
  nextFocusId: string,
}

export default interface EditorCoreState {
  dropState: DropStateStore
  focus: FocusStore
}
